import React from 'react';

/**
 * 공속 탭의 차림 — **사이트의 다른 탭과 같다.**
 *
 * 한동안 둥봇처럼 어두운 갈색 판으로 그렸다가 돌렸다. 한 탭만 어두우면 사이트 안에서
 * 다른 곳에 온 것처럼 보이고, 다크모드도 사이트 방식(밝기만 뒤집기)과 어긋났다.
 * 흰 카드·파란 강조·사이트 변수(`var(--bg-card)`, `var(--text-main)`)를 그대로 쓴다 —
 * 그래야 사이트 다크모드가 이 탭도 같이 뒤집는다.
 *
 * 색은 한곳에 모아 둔다. 판정 색(초록·파랑·보라·주황·빨강)이 여러 화면에 흩어지면
 * 같은 뜻이 다른 색으로 나오기 시작한다.
 */

export const T = {
    /** 탭 바탕 — 휴가·방덱 탭과 같은 보라-파랑 띠 */
    bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    /** 카드 — 띠 위에 얹는 흰 판 (휴가·방덱과 같은 값) */
    card: 'rgba(255, 255, 255, 0.95)',
    /** 카드 안에 한 겹 더 (입력칸·작은 판) */
    sunken: 'rgba(102, 126, 234, 0.05)',
    line: 'rgba(102, 126, 234, 0.18)',
    /** 강조 — 사이트의 파랑 */
    gold: '#1976d2',
    text: 'var(--text-main)',
    sub: '#888',
    blue: '#1976d2',
    green: '#2e7d32',
    orange: '#ef6c00',
    red: '#d32f2f',
    purple: '#7c3aed'
};

export const card: React.CSSProperties = {
    background: T.card,
    borderRadius: 20,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    color: T.text
};

export const field: React.CSSProperties = {
    width: '100%',
    background: '#fff',
    border: '1px solid #dfe3e8',
    borderRadius: 8,
    color: T.text,
    outline: 'none',
    fontWeight: 700,
    textAlign: 'right'
};

export const caption: React.CSSProperties = {
    fontSize: 11,
    fontWeight: 700,
    color: '#667eea',
    marginBottom: 3,
    letterSpacing: '-0.2px'
};

export function button(on = true, color: string = T.blue): React.CSSProperties {
    return {
        border: 'none',
        borderRadius: 8,
        padding: '7px 14px',
        fontSize: 12,
        fontWeight: 700,
        cursor: on ? 'pointer' : 'not-allowed',
        background: on ? color : '#cfd8dc',
        color: '#fff'
    };
}

/** 사이트 탭 단추와 같은 보라-파랑 띠 */
export const ACTIVE_GRADIENT = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';

/** 예전에 이 탭만 Pretendard 를 받았다. 이제 사이트 글꼴 그대로 — 아무것도 안 한다 */
export function ensureFont() { /* 사이트 글꼴을 쓴다 */ }

export const FONT_STACK = 'inherit';
